import { Alert } from "reactstrap";
import { useBjelinTranslations } from "../../../hooks/TranslationHooks";

function FieldError({
  errors,
  field,
  className
}: {
  errors: FormattedFormErrors;
  field: string;
  className?: string;
}) {
  const t = useBjelinTranslations();
  const errorCodes = errors?.[field]?.split(":");
  return errorCodes && errorCodes.length > 0 ? (
    <Alert
      color={"danger"}
      className={className ?? "mt-2"}
      field={field}
      error-code={errorCodes[0]}
    >
      {errorCodes.map(errorCode => t(errorCode)).join(":")}
    </Alert>
  ) : null;
}

export default FieldError;
